/* eslint-disable max-classes-per-file */
import { AxiosResponse } from 'axios';
import { http } from 'SharedDir/backend/axios/http';

import SimpleApi from 'SharedDir/backend/api/classes/simpleApi';
import {
  CATALOG_ENDPOINTS,
  CATALOG_MUNICIPALITIES,
  catalogUrl,
  measureUrl,
} from 'SharedDir/backend/endpoints/catalogs';
import { Catalogs } from 'SharedDir/declarations/catalogs';
import { PaginationParams } from 'SharedDir/declarations/pagination';

export interface CatalogValueListOptions {
  onlyRoot?: boolean;
  parentId?: number;
  recordIds?: Array<number>;
  paramsKey?: string;
  paramsValue?: 0 | 1;
}

export default class CatalogsApiClass extends SimpleApi<Catalogs.Catalogs, Catalogs.Catalogs> {
  constructor() {
    super(catalogUrl);
  }

  private readonly endpoints = CATALOG_ENDPOINTS;

  public async getParentsIds(slug: Catalogs.CatalogSlug, params: Record<string, any>) {
    const endpoint = this.endpoints.PARENTS_IDS(slug);

    const { data } = (await http({ ...endpoint, params })) as AxiosResponse<{ values: number[] }>;

    return data;
  }

  public ValuesApi(slug: Catalogs.CatalogSlug) {
    return new (class extends SimpleApi<
      Required<Catalogs.CatalogsValueFull>,
      Catalogs.CatalogValueUpdate
    > {
      async getAllValues(params: CatalogValueListOptions = {}) {
        const endpoint = { url: this.url, method: 'get' };
        const { data } = (await http({
          ...endpoint,
          params,
        })) as AxiosResponse<Catalogs.CatalogsFull>;
        return data;
      }
    })(`${this.url}/${slug}`);
  }

  // eslint-disable-next-line class-methods-use-this
  public MeasureApi() {
    return new SimpleApi<Catalogs.Measure, Catalogs.MeasureUpdate>(measureUrl);
  }

  /**
   * Получить информацию по муниципалитетам
   *
   * @returns
   */
  // eslint-disable-next-line class-methods-use-this
  public async getMunicipalitiesInfo() {
    const { data } = (await http({
      ...CATALOG_MUNICIPALITIES,
    })) as AxiosResponse<Catalogs.MunicipalityInfoCatalogList>;
    return data;
  }
}
